module.exports = __webpack_public_path__ + "static/media/upload_photo.7948e041.png";